import { render, staticRenderFns } from "./ActiveContactsWidget.vue?vue&type=template&id=90120890&scoped=true&lang=pug"
import script from "./ActiveContactsWidget.vue?vue&type=script&lang=js"
export * from "./ActiveContactsWidget.vue?vue&type=script&lang=js"
import style0 from "./ActiveContactsWidget.vue?vue&type=style&index=0&id=90120890&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90120890",
  null
  
)

export default component.exports